import { render, staticRenderFns } from "./FontAwesomeIcon.vue?vue&type=template&id=360c7c91&"
import script from "./FontAwesomeIcon.vue?vue&type=script&lang=ts&"
export * from "./FontAwesomeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports